import { defineMessages } from 'react-intl';

export default defineMessages({
  returnEmailMessageHeading: {
    description: 'returnSettings.returnEmailMessageHeading',
    defaultMessage: 'Return email message',
    id: 'HiZSl9',
  },
  standardReturnsEmailMessageDescription: {
    description: 'Description for standard returns email message settings',
    defaultMessage: 'This content will appear in the email message sent to customers with their return label.',
    id: 'BURmBd',
  },
  standardReturnsEmailMessagePlaceholder: {
    description: 'Placeholder for standard returns email message',
    defaultMessage: 'Enter your email message here. HTML supported.',
    id: '1jA5/T',
  },
});
